/**
 * The deployed release, baked in at build time by the web image
 * (infra/docker/Dockerfile.web passes VERSION and COMMIT to Vite).
 */
export function versionLabel(version: string | undefined, commit: string | undefined): string {
  const v = (version ?? '').trim();
  if (!v || v === 'dev') return 'Entwicklungsstand';
  const c = (commit ?? '').trim();
  const short = c && c !== 'unknown' ? ` · ${c.slice(0, 7)}` : '';
  return `v${v.replace(/^v/, '')}${short}`;
}

export const appVersionLabel = versionLabel(
  import.meta.env.VITE_APP_VERSION as string | undefined,
  import.meta.env.VITE_APP_COMMIT as string | undefined,
);
